import Grid from '@mui/material/Grid';
import React from 'react';
import TextFieldComp from '../../../components/TextField/textFieldComp';
import Box from '@mui/material/Box';
import ButtonComp from '../../../components/Button/buttonComp';
import PropTypes from 'prop-types';
import {useFormik} from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  cdCode: Yup.string()
    .matches(/^[a-zA-Z0-9\s\W]*$/, 'Invalid CD Code')
    .max(50, 'Invalid CD Code')
    .required('CD Code is required'),
  cdType: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Invalid CD Type')
    .max(30, 'Invalid CD Type')
    .required('CD Type is required'),
  brand: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Invalid Brand')
    .max(30, 'Invalid Brand')
    .required('Brand is required'),
  productColor: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Invalid Product Colour')
    .max(30, 'Invalid Product Colour')
    .required('Product Colour is required'),
  modelNumber: Yup.string()
    .matches(/^[a-zA-Z0-9\s\W]*$/, 'Invalid Model Number')
    .max(50, 'Invalid Model Number')
    .required('Model Number is required'),
  vendor: Yup.string()
    .matches(/^[a-zA-Z\s]*$/, 'Invalid Vendor')
    .max(30, 'Invalid Vendor')
    .required('Vendor is required'),
  customerSellingPrice: Yup.string()
    .test(
      'customer-greater-then-0',
      'Customer Selling Price must be greater than 0',
      function (value) {
      return (value) > 0;
      },
    )
  .matches(/^\d{1,10}(\.\d{1,})?$/, 'Invalid Customer Selling Price')
  .required('Customer Selling Price is required'),
});

function AddEditConsumerDurable({
  closeModal = () => {},
  type = 'add',
  selectedRowObject = {},
  updateConsumerMaster,
}) {
  const formik = useFormik({
    initialValues:
      type === 'add'
        ? {
            cdCode: '',
            cdType: '',
            brand: '',
            productColor: '',
            modelNumber: '',
            vendor: '',
            customerSellingPrice: '',
          }
        : selectedRowObject,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async values => {
      try {
        await updateConsumerMaster(values);
        closeModal();
      } catch (error) {
        console.error('API Error:', error);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <Box sx={{display: 'flex', flexDirection: 'column', gap: '48px'}}>
        <Grid container spacing={'16px'}>
          <Grid item xs={12} md={6}>
            <TextFieldComp
              label="CD code"
              name="cdCode"
              required
              value={formik.values.cdCode}
              onChange={formik.handleChange}
              error={formik.touched.cdCode && Boolean(formik.errors.cdCode)}
              errorMessage={formik.touched.cdCode && formik.errors.cdCode}
              onBlur={formik.handleBlur}
              maxLength={50}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldComp
              label="CD type"
              name="cdType"
              required
              value={formik.values.cdType}
              onChange={formik.handleChange}
              error={formik.touched.cdType && Boolean(formik.errors.cdType)}
              errorMessage={formik.touched.cdType && formik.errors.cdType}
              onBlur={formik.handleBlur}
              maxLength={30}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldComp
              label="Brand"
              name="brand"
              required
              value={formik.values.brand}
              onChange={formik.handleChange}
              error={formik.touched.brand && Boolean(formik.errors.brand)}
              errorMessage={formik.touched.brand && formik.errors.brand}
              onBlur={formik.handleBlur}
              maxLength={30}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldComp
              label="Product colour"
              name="productColor"
              required
              value={formik.values.productColor}
              onChange={formik.handleChange}
              error={
                formik.touched.productColor &&
                Boolean(formik.errors.productColor)
              }
              errorMessage={
                formik.touched.productColor && formik.errors.productColor
              }
              onBlur={formik.handleBlur}
              maxLength={30}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldComp
              label="Model number"
              name="modelNumber"
              required
              value={formik.values.modelNumber}
              onChange={formik.handleChange}
              error={
                formik.touched.modelNumber && Boolean(formik.errors.modelNumber)
              }
              errorMessage={
                formik.touched.modelNumber && formik.errors.modelNumber
              }
              onBlur={formik.handleBlur}
              maxLength={50}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldComp
              label="Vendor"
              name="vendor"
              required
              value={formik.values.vendor}
              onChange={formik.handleChange}
              error={formik.touched.vendor && Boolean(formik.errors.vendor)}
              errorMessage={formik.touched.vendor && formik.errors.vendor}
              onBlur={formik.handleBlur}
              maxLength={30}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldComp
              label="Customer selling price (₹)"
              name="customerSellingPrice"
              required
              value={formik.values.customerSellingPrice}
              onChange={formik.handleChange}
              error={
                formik.touched.customerSellingPrice &&
                Boolean(formik.errors.customerSellingPrice)
              }
              errorMessage={
                formik.touched.customerSellingPrice &&
                formik.errors.customerSellingPrice
              }
              onBlur={formik.handleBlur}
              maxLength={10}
              type="text"
            />
          </Grid>
        </Grid>
        <Grid container spacing={'16px'}>
          <Grid item xs={12} md={6}>
            <ButtonComp
              variant="outlined"
              className="text-bold-16px"
              value="Cancel"
              height="48px"
              width="100%"
              padding="14px 24px"
              textcolor="#F37021"
              borderRadius="8px"
              border="1px solid #F37021"
              onClick={closeModal}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <ButtonComp
              type="submit"
              className="text-bold-16px"
              value={type === 'add' ? 'Add' : 'Save'}
              disabled={!formik.dirty || !formik.isValid}
              gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
              height="48px"
              width="100%"
              padding="14px 24px"
              textcolor="#fff"
              borderRadius="8px"
            />
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}

AddEditConsumerDurable.propTypes = {
  closeModal: PropTypes.func,
  type: PropTypes.string,
  selectedRowObject: PropTypes.object,
  updateConsumerMaster: PropTypes.func.isRequired,
};

export default AddEditConsumerDurable;
